import { render, staticRenderFns } from "./PreviredFacialRecognition.vue?vue&type=template&id=1b8f0ad0&scoped=true"
import script from "./PreviredFacialRecognition.vue?vue&type=script&lang=js"
export * from "./PreviredFacialRecognition.vue?vue&type=script&lang=js"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./PreviredFacialRecognition.vue?vue&type=style&index=0&id=1b8f0ad0&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1b8f0ad0",
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fulfillment-previred-widget/fulfillment-previred-widget/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b8f0ad0')) {
      api.createRecord('1b8f0ad0', component.options)
    } else {
      api.reload('1b8f0ad0', component.options)
    }
    module.hot.accept("./PreviredFacialRecognition.vue?vue&type=template&id=1b8f0ad0&scoped=true", function () {
      api.rerender('1b8f0ad0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PreviredFacialRecognition.vue"
export default component.exports